export const DAY_SECONDS = 86400;
export const FINALIZATION_DELAY_SECONDS = 3 * 3600;
// Finite, serializable watermark for derived snapshots. Persistent storage uses
// expiresAt=null, not a very long TTL. Only explicit clear/eviction removes it.
export const RETAINED_FRESH_UNTIL = Number.MAX_SAFE_INTEGER;

export const finalizationBoundary = (bucketWidth: '1h' | '1d', fetchedAt = Date.now()): number => {
  const width = bucketWidth === '1h' ? 3600 : DAY_SECONDS;
  return Math.floor((fetchedAt / 1000 - FINALIZATION_DELAY_SECONDS) / width) * width;
};
